import { Observable } from 'rxjs';
/* tslint:enable:max-line-length */
export function withLatestFromConflated(...args) {
    // return withLatestFrom(...args); // uncomment this line and comment everything else when you don't trust this code and need to debug other stuff
    return (source) => {
        const observables = args;
        return new Observable((subscriber) => {
            const values = new Array(observables.length + 1); // spot 0 is for our value
            const subscriptions = observables.map((obs, i) => obs.subscribe((x) => {
                return (values[i + 1] = x);
            }, subscriber.error.bind(subscriber)));
            const sourceSubscription = source.subscribe((next) => {
                values[0] = next;
                subscriber.next(values);
            }, subscriber.error.bind(subscriber), subscriber.complete.bind(subscriber));
            return () => {
                sourceSubscription.unsubscribe();
                for (const sub of subscriptions) {
                    sub.unsubscribe();
                }
            };
        });
    };
}
//# sourceMappingURL=withLatestFromConflated.js.map